module.exports = __webpack_public_path__ + "img/reference-schatzmann.9b8ad08c.webp";